import HouseList from "./HouseList";

export default HouseList;
